// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { Batch, BatchInfo, GitHubAccountInfo, GitHubAccountType, GitHubRepo } from "./TypeDefinitions.ts"

export interface Integrations {
  hasLinkedGitHubAccount(): Promise<boolean>

  listAuthorizedGitHubAccounts(): Promise<GitHubAccountInfo[]>

  searchGitHubRepositories(login: string, accountType: GitHubAccountType, query: string, batch: BatchInfo): Promise<Batch<GitHubRepo>>

  startLinkGitHubAccountFlow(backUrl: string): Promise<string>

  unlinkGitHubAccount(): Promise<void>
}

export class IntegrationsClient implements Integrations {
  constructor(private service: ApiService) {}

  async hasLinkedGitHubAccount(): Promise<boolean> {
    return getResult(await this.service.rpc<boolean, never>("Integrations/hasLinkedGitHubAccount", {
    }))
  }

  async listAuthorizedGitHubAccounts(): Promise<GitHubAccountInfo[]> {
    return getResult(await this.service.rpc<GitHubAccountInfo[], never>("Integrations/listAuthorizedGitHubAccounts", {
    }))
  }

  async searchGitHubRepositories(login: string, accountType: GitHubAccountType, query: string, batch: BatchInfo): Promise<Batch<GitHubRepo>> {
    return getResult(await this.service.rpc<Batch<GitHubRepo>, never>("Integrations/searchGitHubRepositories", {
      login: login,
      accountType: accountType,
      query: query,
      batch: batch,
    }))
  }

  async startLinkGitHubAccountFlow(backUrl: string): Promise<string> {
    return getResult(await this.service.rpc<string, never>("Integrations/startLinkGitHubAccountFlow", {
      backUrl: backUrl,
    }))
  }

  async unlinkGitHubAccount(): Promise<void> {
    return getResult(await this.service.rpc<void, never>("Integrations/unlinkGitHubAccount", {
    }))
  }

}

